//import env from "react-dotenv";
//For Application constant and other default values
import { getEnv } from './envConfig'
import { hotel_list } from './hotel_list'

//export const keycloak_client_secret = process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET
//export const keycloak_client_id = process.env.REACT_APP_KEYCLOAK_CLIENT_ID
//export const PRINT_URL = process.env.REACT_APP_PRINT_URL

let env = getEnv()

export const keycloak_client_secret = env.KEYCLOAK_CLIENT_SECRET
export const keycloak_client_id = env.KEYCLOAK_CLIENT_ID
export const cloud_keycloak_client_secret = env.CLOUD_KEYCLOAK_CLIENT_SECRET
export const cloud_keycloak_client_id = env.CLOUD_KEYCLOAK_CLIENT_ID
export const PRINT_URL = env.PRINT_URL


export const refresh_befor = 86400 //for 24 hours

export const version = "0.1.0.0"

export const caseSaleCharges = 10

export const systemCurrencyType = "Rs"

export const hospitalDetails = {
  hospitalAddressLine1: "OLABODDUWEOSU (PVT)LTD",
  hospitalAddressLine2: "OFFICE/ FACTORY 235/10",
  hospitalAddressLine3: "OLABODUWA, GONAPOLA, HORANA",
  hospitalEmail: "olaboduwaosu@gmail.com",
  tele:'+94 342208635',
  mobile:'+94 765334626',
  web:'olaboduwaosu.lk',
  facebook:'olaboduwa nila weda madura.facebook.com'

}



export const citizenship = [{ label: 'Sri Lankan' }, { label: 'Foreign' }]

export const ethic_group = [
  { label: 'Sinhala' },
  { label: 'Burger' },
  { label: 'Sri Lankan Moor' },
  { label: 'Sri Lankan Tamil' },
  { label: 'Malay' },
  { label: 'Other' },
]

export const religion = [
  { label: 'Buddhist' },
  { label: 'Hindu' },
  { label: 'Christian' },
  { label: 'Islam' },
  { label: 'Other' },
  { label: 'Unknown' },
]

export const room_type = [
  { label: 'Single Rooms', value: 'Single Rooms' },
  { label: 'Double Rooms', value: 'Double Rooms' },
  { label: 'Duluxe Rooms', value: 'Duluxe Rooms' },
  { label: 'Family Rooms with Balcony', value: 'Family Rooms with Balcony' },
]

export const smoking_status = [
  { label: 'Smoking ', value: 'Smorking' },
  { label: 'No Smoking', value: 'No Smoking' },
 
]

export const view = [
  { label: 'Pool View', value: 'Pool View' },
  { label: 'Garden View', value: 'Garden View' },
  { label: 'Sea View', value: 'Sea View' },
 
]


export const bathroom_faci = [
  { label: 'Free toiletries ', value: 'Free toiletries' },
  { label: 'Shower', value: 'Shower' },
  { label: 'Toilet', value: 'Toilet' },
  { label: 'Towels', value: 'Towels' },
  { label: 'Hairdryer', value: 'Hairdryer' },
  { label: 'Toilet paper', value: 'Toilet paper' },
 
]

export const other_faci = [
  { label: 'Balcony ', value: 'Balcony' },
  { label: 'Air conditioning', value: 'Air conditioning' },
  { label: 'Safety deposit box', value: 'Safety deposit box' },
  { label: 'Hardwood or parquet floors', value: 'Hardwood or parquet floors' },
  { label: 'Linen', value: 'Linen' },
  { label: 'Socket near the bed ', value: 'Socket near the bed ' },
  { label: 'Desk', value: 'Desk' },
  { label: 'TV', value: 'TV' },
  { label: 'Sofa', value: 'Sofa' },
  { label: 'Refrigerator', value: 'Refrigerator' },
  { label: 'Telephone', value: 'Telephone' },
  { label: 'Tea/Coffee maker ', value: 'Tea/Coffee maker' },
  { label: 'Interconnected room(s) available', value: 'Interconnected room(s) available' },
  { label: 'Fan', value: 'Fan' },
  { label: 'Outdoor furniture', value: 'Outdoor furniture' },
  { label: 'Wake-up service', value: 'Wake-up service' },
  { label: 'Wardrobe or closet', value: 'Wardrobe or closet' },
  { label: 'Upper floors accessible by stairs only', value: 'Upper floors accessible by stairs only' },
  { label: 'Clothes rack', value: 'Clothes rack' },
  { label: 'Drying rack for clothing', value: 'Drying rack for clothing' },
  { label: 'Sofa bed', value: 'Sofa bed' },
 
]


export const facilities = [
  { label: 'Balcony ', value: 'Balcony' },
  { label: 'Air conditioning', value: 'Air conditioning' },
  { label: 'Safety deposit box', value: 'Safety deposit box' },
  { label: 'Hardwood or parquet floors', value: 'Hardwood or parquet floors' },
  { label: 'Linen', value: 'Linen' },
  { label: 'Socket near the bed ', value: 'Socket near the bed ' },
  { label: 'Desk', value: 'Desk' },
  { label: 'TV', value: 'TV' },
  { label: 'Sofa', value: 'Sofa' },
  { label: 'Refrigerator', value: 'Refrigerator' },
  { label: 'Telephone', value: 'Telephone' },
  { label: 'Tea/Coffee maker ', value: 'Tea/Coffee maker' },
  { label: 'Interconnected room(s) available', value: 'Interconnected room(s) available' },
  { label: 'Fan', value: 'Fan' },
  { label: 'Outdoor furniture', value: 'Outdoor furniture' },
  { label: 'Wake-up service', value: 'Wake-up service' },
  { label: 'Wardrobe or closet', value: 'Wardrobe or closet' },
  { label: 'Upper floors accessible by stairs only', value: 'Upper floors accessible by stairs only' },
  { label: 'Clothes rack', value: 'Clothes rack' },
  { label: 'Drying rack for clothing', value: 'Drying rack for clothing' },
  { label: 'Sofa bed', value: 'Sofa bed' },
 
]



export const admission_type = [
  { label: 'Clinic', value: "Clinic" },
  { label: 'Ward', value: "Ward" },
  { label: 'Room', value: "Room" },
  { label: 'OPD', value: "OPD" }
]

export const admission_mode = [
  { label: 'Direct' },
  { label: 'Transferred from Hospital' },
  { label: 'Referred from Clinic' },
  { label: 'Referred from Ward' },
  { label: 'Referred by The Consultant' },
  { label: 'For Hemodialysis' },
]

export const districtList = [
  { value: 'Ampara', label: 'Ampara', province: 'Eastern' },
  { value: 'Anuradhapura', label: 'Anuradhapura', province: 'North Central' },
  { value: 'Badulla', label: 'Badulla', province: 'Uva' },
  { value: 'Batticaloa', label: 'Batticaloa', province: 'Eastern' },
  { value: 'Colombo', label: 'Colombo', province: 'Western' },
  { value: 'Galle', label: 'Galle', province: 'Southern' },
  { value: 'Gampaha', label: 'Gampaha', province: 'Western' },
  { value: 'Hambantota', label: 'Hambantota', province: 'Southern' },
  { value: 'Jaffna', label: 'Jaffna', province: 'Northern' },
  { value: 'Kalutara', label: 'Kalutara', province: 'Western' },
  { value: 'Kandy', label: 'Kandy', province: 'Central' },
  { value: 'Kegalle', label: 'Kegalle', province: 'Sabaragamuwa' },
  { value: 'Kilinochchi', label: 'Kilinochchi', province: 'Northern' },
  { value: 'Kurunegala', label: 'Kurunegala', province: 'North Western' },
  { value: 'Mannar', label: 'Mannar', province: 'Northern' },
  { value: 'Matale', label: 'Matale', province: 'Central' },
  { value: 'Matara', label: 'Matara', province: 'Southern' },
  { value: 'Monaragala', label: 'Monaragala', province: 'Uva' },
  { value: 'Mullaitivu', label: 'Mullaitivu', province: 'Northern' },
  { value: 'Nuwara Eliya', label: 'Nuwara Eliya', province: 'Central' },
  { value: 'Polonnaruwa', label: 'Polonnaruwa', province: 'North Central' },
  { value: 'Puttalam', label: 'Puttalam', province: 'North Western' },
  { value: 'Rathnapura', label: 'Rathnapura', province: 'Sabaragamuwa' },
  { value: 'Trincomalee', label: 'Trincomalee', province: 'Eastern' },
  { value: 'Vavuniya', label: 'Vavuniya', province: 'Northern' },
]

export const provinceList = [
  // { label: 'All', value: 'all' },
  { value: 'Southern', label: 'Southern' },
  { value: 'Western', label: 'Western' },
  { value: 'Central', label: 'Central' },
  { value: 'Uva', label: 'Uva' },
  { value: 'Sabaragamuwa', label: 'Sabaragamuwa' },
  { value: 'North Western', label: 'North Western' },
  { value: 'North Central', label: 'North Central' },
  { value: 'Northern', label: 'Northern' },
  { value: 'Eastern', label: 'Eastern' },
]

export const hospital_user_type = [
  { type: 'Doctor', lable: 'Doctor' },
  { type: 'Nurse', lable: 'Nurse' },
  { type: 'Front Desk', lable: 'Front Desk' },
  { type: 'Billing Desk', lable: 'Billing Desk' },

]

export const hospital_bed_types = [
  { type: 'Normal', lable: 'Normal' },
  { type: 'ICU Bed', lable: 'ICU Bed' },
  { type: 'Electric beds', lable: 'Electric beds' },
  { type: 'Manual beds', lable: 'Manual beds' },
  { type: 'Low beds', lable: 'Low beds' },
  { type: 'Hi-low beds', lable: 'Hi-low beds' },
  { type: 'Acute care with air loss mattresses', lable: 'Acute care with air loss mattresses' },
  { type: 'Clinitron beds', lable: 'Clinitron beds' },
  { type: 'Air fluidized beds', lable: 'Air fluidized beds' }

]

export const contact_code = [
  { country: 'Sri Lanka', value: '+94' },
  { country: 'India', value: '+91' },
  { country: 'United States', value: '+1' },
  { country: 'United Kingdom', value: '+44' },
  { country: 'Canada', value: '+1' },
  { country: 'Australia', value: '+61' },
  { country: 'Germany', value: '+49' },
  { country: 'France', value: '+33' },
  { country: 'China', value: '+86' },
  { country: 'Japan', value: '+81' },
  { country: 'Pakistan', value: '+92' },
  { country: 'Bangladesh', value: '+880' },
  { country: 'Nepal', value: '+977' },
  { country: 'Maldives', value: '+960' },
  { country: 'Singapore', value: '+65' },
  { country: 'Malaysia', value: '+60' },
  { country: 'Indonesia', value: '+62' },
  { country: 'Thailand', value: '+66' },
  { country: 'South Korea', value: '+82' },
  { country: 'Philippines', value: '+63' },
  { country: 'Russia', value: '+7' },
  { country: 'Brazil', value: '+55' },
  { country: 'South Africa', value: '+27' },
  { country: 'Saudi Arabia', value: '+966' },
  { country: 'United Arab Emirates', value: '+971' },
  { country: 'Qatar', value: '+974' },
  { country: 'Kuwait', value: '+965' },
  { country: 'Oman', value: '+968' },
  { country: 'Turkey', value: '+90' },
];

export const languages = [
  { language: "Mandarin Chinese" },
  { language: "Spanish" },
  { language: "Arabic" },
  { language: "Bengali" },
  { language: "Russian" },
  { language: "Portuguese" },
  { language: "Urdu" },
  { language: "Indonesian" },
  { language: "German" },
  { language: "Japanese" },
  { language: "Swahili" },
  { language: "Marathi" },
  { language: "Telugu" },
  { language: "Turkish" },
  { language: "Tamil" },
  { language: "Punjabi" },
  { language: "Korean" },
  { language: "Vietnamese" },
  { language: "Javanese" },
  { language: "Wu Chinese (Shanghainese)" },
  { language: "Hausa" },
  { language: "Thai" },
  { language: "Gujarati" },
  { language: "Polish" },
  { language: "Ukrainian" },
  { language: "Yoruba" },
  { language: "Malayalam" },
  { language: "Odia (Oriya)" },
  { language: "Burmese" },
  { language: "Amharic" },
  { language: "Farsi (Persian)" },
  { language: "Romanian" },
  { language: "Pashto" },
  { language: "Sindhi" },
  { language: "Cebuano" },
  { language: "Nepali" },
  { language: "Dutch" },
  { language: "Serbo-Croatian" },
  { language: "Malagasy" },
  { language: "Malay" },
  { language: "Igbo" },
  { language: "Uzbek" },
  { language: "Kannada" },
  { language: "Azerbaijani" },
  { language: "Hungarian" },
  { language: "Greek" },
  { language: "Czech" },
  { language: "Kazakh" },
  { language: "Zulu" }
];

export const currency = [
  { country: "Afghanistan", currency: "Afghan Afghani", code: "AFN", symbol: "؋", dial_code: "+93" },
  { country: "Albania", currency: "Albanian Lek", code: "ALL", symbol: "L", dial_code: "+355" },
  { country: "Algeria", currency: "Algerian Dinar", code: "DZD", symbol: "دج", dial_code: "+213" },
  { country: "Andorra", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+376" },
  { country: "Angola", currency: "Angolan Kwanza", code: "AOA", symbol: "Kz", dial_code: "+244" },
  { country: "Antigua and Barbuda", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-268" },
  { country: "Argentina", currency: "Argentine Peso", code: "ARS", symbol: "$", dial_code: "+54" },
  { country: "Armenia", currency: "Armenian Dram", code: "AMD", symbol: "֏", dial_code: "+374" },
  { country: "Australia", currency: "Australian Dollar", code: "AUD", symbol: "A$", dial_code: "+61" },
  { country: "Austria", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+43" },
  { country: "Azerbaijan", currency: "Azerbaijani Manat", code: "AZN", symbol: "₼", dial_code: "+994" },
  { country: "Bahamas", currency: "Bahamian Dollar", code: "BSD", symbol: "B$", dial_code: "+1-242" },
  { country: "Bahrain", currency: "Bahraini Dinar", code: "BHD", symbol: ".د.ب", dial_code: "+973" },
  { country: "Bangladesh", currency: "Bangladeshi Taka", code: "BDT", symbol: "৳", dial_code: "+880" },
  { country: "Barbados", currency: "Barbadian Dollar", code: "BBD", symbol: "Bds$", dial_code: "+1-246" },
  { country: "Belarus", currency: "Belarusian Ruble", code: "BYN", symbol: "Br", dial_code: "+375" },
  { country: "Belgium", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+32" },
  { country: "Belize", currency: "Belize Dollar", code: "BZD", symbol: "BZ$", dial_code: "+501" },
  { country: "Benin", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+229" },
  { country: "Bhutan", currency: "Bhutanese Ngultrum", code: "BTN", symbol: "Nu.", dial_code: "+975" },
  { country: "Bolivia", currency: "Bolivian Boliviano", code: "BOB", symbol: "Bs.", dial_code: "+591" },
  { country: "Bosnia and Herzegovina", currency: "Bosnia-Herzegovina Convertible Mark", code: "BAM", symbol: "KM", dial_code: "+387" },
  { country: "Botswana", currency: "Botswana Pula", code: "BWP", symbol: "P", dial_code: "+267" },
  { country: "Brazil", currency: "Brazilian Real", code: "BRL", symbol: "R$", dial_code: "+55" },
  { country: "Brunei", currency: "Brunei Dollar", code: "BND", symbol: "B$", dial_code: "+673" },
  { country: "Bulgaria", currency: "Bulgarian Lev", code: "BGN", symbol: "лв", dial_code: "+359" },
  { country: "Burkina Faso", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+226" },
  { country: "Burundi", currency: "Burundian Franc", code: "BIF", symbol: "FBu", dial_code: "+257" },
  { country: "Cabo Verde", currency: "Cape Verdean Escudo", code: "CVE", symbol: "$", dial_code: "+238" },
  { country: "Cambodia", currency: "Cambodian Riel", code: "KHR", symbol: "៛", dial_code: "+855" },
  { country: "Cameroon", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+237" },
  { country: "Canada", currency: "Canadian Dollar", code: "CAD", symbol: "C$", dial_code: "+1" },
  { country: "Central African Republic", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+236" },
  { country: "Chad", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+235" },
  { country: "Chile", currency: "Chilean Peso", code: "CLP", symbol: "$", dial_code: "+56" },
  { country: "China", currency: "Chinese Yuan Renminbi", code: "CNY", symbol: "¥", dial_code: "+86" },
  { country: "Colombia", currency: "Colombian Peso", code: "COP", symbol: "$", dial_code: "+57" },
  { country: "Comoros", currency: "Comorian Franc", code: "KMF", symbol: "CF", dial_code: "+269" },
  { country: "Congo, Democratic Republic of the", currency: "Congolese Franc", code: "CDF", symbol: "FC", dial_code: "+243" },
  { country: "Congo, Republic of the", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+242" },
  { country: "Costa Rica", currency: "Costa Rican Colón", code: "CRC", symbol: "₡", dial_code: "+506" },
  { country: "Côte d'Ivoire", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+225" },
  { country: "Croatia", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+385" },
  { country: "Cuba", currency: "Cuban Peso", code: "CUP", symbol: "$", dial_code: "+53" },
  { country: "Cyprus", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+357" },
  { country: "Czechia", currency: "Czech Koruna", code: "CZK", symbol: "Kč", dial_code: "+420" },
  { country: "Denmark", currency: "Danish Krone", code: "DKK", symbol: "kr", dial_code: "+45" },
  { country: "Djibouti", currency: "Djiboutian Franc", code: "DJF", symbol: "Fdj", dial_code: "+253" },
  { country: "Dominica", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-767" },
  { country: "Dominican Republic", currency: "Dominican Peso", code: "DOP", symbol: "RD$", dial_code: "+1-809" },
  { country: "Ecuador", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+593" },
  { country: "Egypt", currency: "Egyptian Pound", code: "EGP", symbol: "£", dial_code: "+20" },
  { country: "El Salvador", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+503" },
  { country: "Equatorial Guinea", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+240" },
  { country: "Eritrea", currency: "Eritrean Nakfa", code: "ERN", symbol: "Nfk", dial_code: "+291" },
  { country: "Estonia", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+372" },
  { country: "Eswatini", currency: "Swazi Lilangeni", code: "SZL", symbol: "E", dial_code: "+268" },
  { country: "Ethiopia", currency: "Ethiopian Birr", code: "ETB", symbol: "Br", dial_code: "+251" },
  { country: "Fiji", currency: "Fijian Dollar", code: "FJD", symbol: "FJ$", dial_code: "+679" },
  { country: "Finland", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+358" },
  { country: "France", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+33" },
  { country: "Gabon", currency: "Central African CFA franc", code: "XAF", symbol: "FCFA", dial_code: "+241" },
  { country: "Gambia", currency: "Gambian Dalasi", code: "GMD", symbol: "D", dial_code: "+220" },
  { country: "Georgia", currency: "Georgian Lari", code: "GEL", symbol: "₾", dial_code: "+995" },
  { country: "Germany", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+49" },
  { country: "Ghana", currency: "Ghanaian Cedi", code: "GHS", symbol: "₵", dial_code: "+233" },
  { country: "Greece", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+30" },
  { country: "Grenada", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-473" },
  { country: "Guatemala", currency: "Guatemalan Quetzal", code: "GTQ", symbol: "Q", dial_code: "+502" },
  { country: "Guinea", currency: "Guinean Franc", code: "GNF", symbol: "FG", dial_code: "+224" },
  { country: "Guinea-Bissau", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+245" },
  { country: "Guyana", currency: "Guyanese Dollar", code: "GYD", symbol: "G$", dial_code: "+592" },
  { country: "Haiti", currency: "Haitian Gourde", code: "HTG", symbol: "G", dial_code: "+509" },
  { country: "Honduras", currency: "Honduran Lempira", code: "HNL", symbol: "L", dial_code: "+504" },
  { country: "Hungary", currency: "Hungarian Forint", code: "HUF", symbol: "Ft", dial_code: "+36" },
  { country: "Iceland", currency: "Icelandic Króna", code: "ISK", symbol: "kr", dial_code: "+354" },
  { country: "India", currency: "Indian Rupee", code: "INR", symbol: "₹", dial_code: "+91" },
  { country: "Indonesia", currency: "Indonesian Rupiah", code: "IDR", symbol: "Rp", dial_code: "+62" },
  { country: "Iran", currency: "Iranian Rial", code: "IRR", symbol: "﷼", dial_code: "+98" },
  { country: "Iraq", currency: "Iraqi Dinar", code: "IQD", symbol: "ع.د", dial_code: "+964" },
  { country: "Ireland", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+353" },
  { country: "Israel", currency: "Israeli New Shekel", code: "ILS", symbol: "₪", dial_code: "+972" },
  { country: "Italy", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+39" },
  { country: "Jamaica", currency: "Jamaican Dollar", code: "JMD", symbol: "J$", dial_code: "+1-876" },
  { country: "Japan", currency: "Japanese Yen", code: "JPY", symbol: "¥", dial_code: "+81" },
  { country: "Jordan", currency: "Jordanian Dinar", code: "JOD", symbol: "د.ا", dial_code: "+962" },
  { country: "Kazakhstan", currency: "Kazakhstani Tenge", code: "KZT", symbol: "₸", dial_code: "+7" },
  { country: "Kenya", currency: "Kenyan Shilling", code: "KES", symbol: "KSh", dial_code: "+254" },
  { country: "Kiribati", currency: "Australian Dollar", code: "AUD", symbol: "A$", dial_code: "+686" },
  { country: "Kuwait", currency: "Kuwaiti Dinar", code: "KWD", symbol: "د.ك", dial_code: "+965" },
  { country: "Kyrgyzstan", currency: "Kyrgyzstani Som", code: "KGS", symbol: "с", dial_code: "+996" },
  { country: "Laos", currency: "Lao Kip", code: "LAK", symbol: "₭", dial_code: "+856" },
  { country: "Latvia", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+371" },
  { country: "Lebanon", currency: "Lebanese Pound", code: "LBP", symbol: "ل.ل", dial_code: "+961" },
  { country: "Lesotho", currency: "Lesotho Loti", code: "LSL", symbol: "L", dial_code: "+266" },
  { country: "Liberia", currency: "Liberian Dollar", code: "LRD", symbol: "L$", dial_code: "+231" },
  { country: "Libya", currency: "Libyan Dinar", code: "LYD", symbol: "ل.د", dial_code: "+218" },
  { country: "Liechtenstein", currency: "Swiss Franc", code: "CHF", symbol: "Fr", dial_code: "+423" },
  { country: "Lithuania", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+370" },
  { country: "Luxembourg", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+352" },
  { country: "Madagascar", currency: "Malagasy Ariary", code: "MGA", symbol: "Ar", dial_code: "+261" },
  { country: "Malawi", currency: "Malawian Kwacha", code: "MWK", symbol: "MK", dial_code: "+265" },
  { country: "Malaysia", currency: "Malaysian Ringgit", code: "MYR", symbol: "RM", dial_code: "+60" },
  { country: "Maldives", currency: "Maldivian Rufiyaa", code: "MVR", symbol: "Rf", dial_code: "+960" },
  { country: "Mali", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+223" },
  { country: "Malta", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+356" },
  { country: "Marshall Islands", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+692" },
  { country: "Mauritania", currency: "Mauritanian Ouguiya", code: "MRU", symbol: "UM", dial_code: "+222" },
  { country: "Mauritius", currency: "Mauritian Rupee", code: "MUR", symbol: "₨", dial_code: "+230" },
  { country: "Mexico", currency: "Mexican Peso", code: "MXN", symbol: "$", dial_code: "+52" },
  { country: "Micronesia", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+691" },
  { country: "Moldova", currency: "Moldovan Leu", code: "MDL", symbol: "L", dial_code: "+373" },
  { country: "Monaco", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+377" },
  { country: "Mongolia", currency: "Mongolian Tögrög", code: "MNT", symbol: "₮", dial_code: "+976" },
  { country: "Montenegro", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+382" },
  { country: "Morocco", currency: "Moroccan Dirham", code: "MAD", symbol: "د.م.", dial_code: "+212" },
  { country: "Mozambique", currency: "Mozambican Metical", code: "MZN", symbol: "MT", dial_code: "+258" },
  { country: "Myanmar", currency: "Burmese Kyat", code: "MMK", symbol: "K", dial_code: "+95" },
  { country: "Namibia", currency: "Namibian Dollar", code: "NAD", symbol: "N$", dial_code: "+264" },
  { country: "Nauru", currency: "Australian Dollar", code: "AUD", symbol: "A$", dial_code: "+674" },
  { country: "Nepal", currency: "Nepalese Rupee", code: "NPR", symbol: "₨", dial_code: "+977" },
  { country: "Netherlands", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+31" },
  { country: "New Zealand", currency: "New Zealand Dollar", code: "NZD", symbol: "NZ$", dial_code: "+64" },
  { country: "Nicaragua", currency: "Nicaraguan Córdoba", code: "NIO", symbol: "C$", dial_code: "+505" },
  { country: "Niger", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+227" },
  { country: "Nigeria", currency: "Nigerian Naira", code: "NGN", symbol: "₦", dial_code: "+234" },
  { country: "North Korea", currency: "North Korean Won", code: "KPW", symbol: "₩", dial_code: "+850" },
  { country: "North Macedonia", currency: "Macedonian Denar", code: "MKD", symbol: "ден", dial_code: "+389" },
  { country: "Norway", currency: "Norwegian Krone", code: "NOK", symbol: "kr", dial_code: "+47" },
  { country: "Oman", currency: "Omani Rial", code: "OMR", symbol: "ر.ع.", dial_code: "+968" },
  { country: "Pakistan", currency: "Pakistani Rupee", code: "PKR", symbol: "₨", dial_code: "+92" },
  { country: "Palau", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+680" },
  { country: "Palestine", currency: "Israeli New Shekel", code: "ILS", symbol: "₪", dial_code: "+970" },
  { country: "Panama", currency: "Panamanian Balboa", code: "PAB", symbol: "B/.", dial_code: "+507" },
  { country: "Papua New Guinea", currency: "Papua New Guinean Kina", code: "PGK", symbol: "K", dial_code: "+675" },
  { country: "Paraguay", currency: "Paraguayan Guaraní", code: "PYG", symbol: "₲", dial_code: "+595" },
  { country: "Peru", currency: "Peruvian Sol", code: "PEN", symbol: "S/", dial_code: "+51" },
  { country: "Philippines", currency: "Philippine Peso", code: "PHP", symbol: "₱", dial_code: "+63" },
  { country: "Poland", currency: "Polish Złoty", code: "PLN", symbol: "zł", dial_code: "+48" },
  { country: "Portugal", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+351" },
  { country: "Qatar", currency: "Qatari Riyal", code: "QAR", symbol: "ر.ق", dial_code: "+974" },
  { country: "Romania", currency: "Romanian Leu", code: "RON", symbol: "lei", dial_code: "+40" },
  { country: "Russia", currency: "Russian Ruble", code: "RUB", symbol: "₽", dial_code: "+7" },
  { country: "Rwanda", currency: "Rwandan Franc", code: "RWF", symbol: "FRw", dial_code: "+250" },
  { country: "Saint Kitts and Nevis", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-869" },
  { country: "Saint Lucia", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-758" },
  { country: "Saint Vincent and the Grenadines", currency: "East Caribbean Dollar", code: "XCD", symbol: "$", dial_code: "+1-784" },
  { country: "Samoa", currency: "Samoan Tala", code: "WST", symbol: "WS$", dial_code: "+685" },
  { country: "San Marino", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+378" },
  { country: "Sao Tome and Principe", currency: "São Tomé and Príncipe Dobra", code: "STN", symbol: "Db", dial_code: "+239" },
  { country: "Saudi Arabia", currency: "Saudi Riyal", code: "SAR", symbol: "ر.س", dial_code: "+966" },
  { country: "Senegal", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+221" },
  { country: "Serbia", currency: "Serbian Dinar", code: "RSD", symbol: "дин", dial_code: "+381" },
  { country: "Seychelles", currency: "Seychellois Rupee", code: "SCR", symbol: "₨", dial_code: "+248" },
  { country: "Sierra Leone", currency: "Sierra Leonean Leone", code: "SLL", symbol: "Le", dial_code: "+232" },
  { country: "Singapore", currency: "Singapore Dollar", code: "SGD", symbol: "S$", dial_code: "+65" },
  { country: "Slovakia", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+421" },
  { country: "Slovenia", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+386" },
  { country: "Solomon Islands", currency: "Solomon Islands Dollar", code: "SBD", symbol: "SI$", dial_code: "+677" },
  { country: "Somalia", currency: "Somali Shilling", code: "SOS", symbol: "Sh.So.", dial_code: "+252" },
  { country: "South Africa", currency: "South African Rand", code: "ZAR", symbol: "R", dial_code: "+27" },
  { country: "South Korea", currency: "South Korean Won", code: "KRW", symbol: "₩", dial_code: "+82" },
  { country: "South Sudan", currency: "South Sudanese Pound", code: "SSP", symbol: "£", dial_code: "+211" },
  { country: "Spain", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+34" },
  { country: "Sri Lanka", currency: "Sri Lankan Rupee", code: "LKR", symbol: "Rs", dial_code: "+94" },
  { country: "Sudan", currency: "Sudanese Pound", code: "SDG", symbol: "ج.س.", dial_code: "+249" },
  { country: "Suriname", currency: "Surinamese Dollar", code: "SRD", symbol: "$", dial_code: "+597" },
  { country: "Sweden", currency: "Swedish Krona", code: "SEK", symbol: "kr", dial_code: "+46" },
  { country: "Switzerland", currency: "Swiss Franc", code: "CHF", symbol: "Fr", dial_code: "+41" },
  { country: "Syria", currency: "Syrian Pound", code: "SYP", symbol: "£S", dial_code: "+963" },
  { country: "Taiwan", currency: "New Taiwan Dollar", code: "TWD", symbol: "NT$", dial_code: "+886" },
  { country: "Tajikistan", currency: "Tajikistani Somoni", code: "TJS", symbol: "ЅM", dial_code: "+992" },
  { country: "Tanzania", currency: "Tanzanian Shilling", code: "TZS", symbol: "TSh", dial_code: "+255" },
  { country: "Thailand", currency: "Thai Baht", code: "THB", symbol: "฿", dial_code: "+66" },
  { country: "Timor-Leste", currency: "United States Dollar", code: "USD", symbol: "$", dial_code: "+670" },
  { country: "Togo", currency: "West African CFA franc", code: "XOF", symbol: "CFA", dial_code: "+228" },
  { country: "Tonga", currency: "Tongan Paʻanga", code: "TOP", symbol: "T$", dial_code: "+676" },
  { country: "Trinidad and Tobago", currency: "Trinidad and Tobago Dollar", code: "TTD", symbol: "TT$", dial_code: "+1-868" },
  { country: "Tunisia", currency: "Tunisian Dinar", code: "TND", symbol: "د.ت", dial_code: "+216" },
  { country: "Turkey", currency: "Turkish Lira", code: "TRY", symbol: "₺", dial_code: "+90" },
  { country: "Turkmenistan", currency: "Turkmenistan Manat", code: "TMT", symbol: "m", dial_code: "+993" },
  { country: "Tuvalu", currency: "Australian Dollar", code: "AUD", symbol: "A$", dial_code: "+688" },
  { country: "Uganda", currency: "Ugandan Shilling", code: "UGX", symbol: "USh", dial_code: "+256" },
  { country: "Ukraine", currency: "Ukrainian Hryvnia", code: "UAH", symbol: "₴", dial_code: "+380" },
  { country: "United Arab Emirates", currency: "UAE Dirham", code: "AED", symbol: "د.إ", dial_code: "+971" },
  { country: "United Kingdom", currency: "British Pound Sterling", code: "GBP", symbol: "£", dial_code: "+44" },
  { country: "United States", currency: "US Dollar", code: "USD", symbol: "$", dial_code: "+1" },
  { country: "Uruguay", currency: "Uruguayan Peso", code: "UYU", symbol: "$U", dial_code: "+598" },
  { country: "Uzbekistan", currency: "Uzbekistani Soʻm", code: "UZS", symbol: "so'm", dial_code: "+998" },
  { country: "Vanuatu", currency: "Vanuatu Vatu", code: "VUV", symbol: "VT", dial_code: "+678" },
  { country: "Vatican City", currency: "Euro", code: "EUR", symbol: "€", dial_code: "+379" },
  { country: "Venezuela", currency: "Venezuelan Bolívar", code: "VES", symbol: "Bs.S", dial_code: "+58" },
  { country: "Vietnam", currency: "Vietnamese Đồng", code: "VND", symbol: "₫", dial_code: "+84" },
  { country: "Yemen", currency: "Yemeni Rial", code: "YER", symbol: "﷼", dial_code: "+967" },
  { country: "Zambia", currency: "Zambian Kwacha", code: "ZMW", symbol: "ZK", dial_code: "+260" },
  { country: "Zimbabwe", currency: "Zimbabwean Dollar", code: "ZWL", symbol: "Z$", dial_code: "+263" }
];


export const penalty_types = [
  { type: 'Fixed Amount', lable: 'Fixed Amount' },
  { type: 'Percentage', lable: 'Percentage' },
];

export const apply_type = [
  { type: 'booking_total', lable: 'Booking total' },
  { type: 'first_night', lable: 'First Night' },
]

export const discount_Type = [
  { value: 'add', lable: 'Add' },
  { value: 'discount', lable: 'Discount' },
]

export const day_of_week = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' },
];

export const user_type = [
  { label: 'Hotel Owner' },
  { label: 'Customer' },
  { label: 'Agent' },
];



export { hotel_list }

export const marital_status = [{ label: 'Single' }, { label: 'Married' }]